import OutsideClickHandler from 'react-outside-click-handler';
import { Dropdown } from '@creditsights/styleguide-web';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import NestedDropdown from '../NestedDropdown';
import { ItemType, NavigationItem } from '../../../../models/Navigation';
import {
  trackNavbarMenuItem,
  trackNavbarSubMenuItem,
  trackNavbarNestedSubMenuItem,
} from '../../../../utils/navigationUtils';

interface NavigationDropdownProps {
  options: NavigationItem[];
  text: string;
  isNestedLeftAligned?: boolean;
  dataTestId?: string;
  isActive?: boolean;
}

const NavigationDropdown = ({
  options,
  text,
  isNestedLeftAligned,
  dataTestId,
  isActive,
}: NavigationDropdownProps): React.ReactElement => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    if (isOpen) {
      trackNavbarMenuItem(text);
    }
  });

  const onSelect = (value) => {
    const dataToBeTracked = options.find((option) => option.to === value);
    if (dataToBeTracked) {
      trackNavbarSubMenuItem(text, dataToBeTracked.text);
    }

    setIsOpen(false);
    if (value.startsWith('http')) {
      window.open(value);
    } else {
      navigate(value);
    }
  };

  const onNestedSelect = (value) => {
    trackNavbarNestedSubMenuItem(options, text, value);
    setIsOpen(false);
    if (value) {
      navigate(value);
    }
  };

  const dropdownOptions = options.map((option) => {
    const optionProps = {
      key: option.text,
      text: option.text,
    };

    if (option.type === ItemType.DROPDOWN) {
      return {
        ...optionProps,
        content: (
          <NestedDropdown
            options={option.options}
            onSelect={onNestedSelect}
            text={option.text}
            isLeftAligned={isNestedLeftAligned}
          />
        ),
      };
    }
    return { ...optionProps, value: option.to };
  });

  return (
    <OutsideClickHandler onOutsideClick={() => setIsOpen(false)}>
      <Dropdown
        className="navbar"
        open={isOpen}
        onClick={() => setIsOpen(!isOpen)}
        options={dropdownOptions}
        withCaretIcon
        text={text}
        // TODO CSNP-1951
        value={isOpen}
        onOptionSelect={onSelect}
        dataTestId={dataTestId}
        isActive={isActive}
      />
    </OutsideClickHandler>
  );
};

export default NavigationDropdown;
